import { inject, Injectable, NgZone } from '@angular/core';
import { UserTrackerService } from '@rma/generic/util/tracking/analytics';
import { IntercomService } from '@rma/generic/util/tracking/intercom';

@Injectable()
export class LazyLoadThirdPartyScriptsService {
  private readonly intercom = inject(IntercomService);
  private readonly userTrackerService = inject(UserTrackerService);
  private readonly zone = inject(NgZone);

  public initialize() {
    this.zone.runOutsideAngular(() => {
      this.intercom.initialise();
      this.userTrackerService.watchUser();
    });
  }
}
